var map = {
	"./0_projectsList.json": 7915,
	"./forschungslabor.json": 3538,
	"./hedera.json": 9622,
	"./hosenrolle.json": 5780,
	"./ichBinSchonTot.json": 9960,
	"./ichWerdeTierSein.json": 5508,
	"./phantomschmerz.json": 419
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 5459;